export default __webpack_public_path__ + "static/media/goldf.dcb14f4c.png";